import { useEffect, useState } from "react";
import api from "../api/axiosPublic";
import "../styles/cursos.css";
import { Link } from "react-router-dom";

export default function Cursos() {
  const [cursos, setCursos] = useState([]);

  useEffect(() => {
    api.get("/cursos").then(res => setCursos(res.data));
  }, []);

  return (
    <div className="cursos-container">
      <h1>Master Class disponibles</h1>

      <div className="cursos-grid">
        {cursos.map(c => (
          <Link
            key={c.id}
            to={`/curso/${c.id}`}
            className="curso-card"
          >
            {/* BADGE CONDICIONAL */}
            {Number(c.precio) > 0 ? (
              <div className="curso-badge">
                3 cuotas<br />Precio contado
              </div>
            ) : (
              <div className="curso-badge curso-badge-gratis">
                GRATUITO
              </div>
            )}

            {c.imagen && (
              <div className="curso-img-container">
                <img
                  src={`https://centromillennials.com/uploads/${c.imagen}`}
                  alt={c.nombre}
                  className="curso-img"
                  loading="lazy"
                />
              </div>
            )}

            <div className="curso-info">
              <h2>{c.nombre}</h2>

              <p className="curso-precio">
                {Number(c.precio) === 0 ? "$0" : `$${c.precio}`}
              </p>

              {c.fecha_clase && (
                <>
                  <p className="curso-fecha">
                    📅 {new Date(c.fecha_clase).toLocaleDateString()}
                  </p>
                  <p className="curso-hora">
                    ⏰ {new Date(c.fecha_clase).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </p>
                </>
              )}
            </div>

            <div className="curso-footer">
              <span className="curso-btn">Ver detalles</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
